export const signConfig = {
    addmark: ['qt', 'pid', 'x', 'y', 'z', 'from', 'content', 'cuid'],
    delmark: ['qt', 'markid', 'from', 'reply_id', 'poi_uid', 'cuid'],
    votemark: ['qt', 'from', 'voteData', 'cuid'],
    replyfeed: ['qt', 'mark_id', 'cuid', 'from', 'page', 'page_size', 'up_floor_id'],
    replysubmit: ['qt', 'mark_id', 'parent_id', 'content', 'srcname', 'from'],
    aroundlistmarks: ['qt', 'pid', 'poi_uid', 'from', 'loc', 'radius', 'needtags', 'cuid', 'mark_id', 'pano_type'],
    getfeed: [
        'qt', 'num', 'cuid', 'from', 'channel_name', 'loc', 'city_id', 'pid',
        'panorama_recommend', 'channel_id', 'page',
        'direct_date', 'mix_channel_name'
    ],
    updatefeednum: ['qt', 'cuid', 'type', 'operate_type', 'pid', 'from', 'scan_time', 'topic_id'],
    getfeedbackandmusic: ['qt', 'cuid', 'from'],
    submitfeedback: ['qt', 'cuid', 'from', 'type', 'id', 'data', 'content', 'title', 'source'],
    msgfeed: ['qt', 'pid', 'from', 'cuid', 'page', 'page_size', 'poi_uid'],
    getTab: ['qt', 'group_name', 'loc', 'city_id', 'direct_channel', 'panorama_recommend'],
    getfeedbytopic: ['qt', 'cuid', 'from', 'topic_id', 'feed_id', 'loc', 'city_id']
};